<template>
    <div class="detail_item items">
        <div class="item long">
            <div class="left">项目名称</div>
            <div class="right">{{ detail.project_name }}</div>
        </div>
        <div class="item">
            <div class="left">项目所属区域</div>
            <div class="right">{{ initArea(detail.area) }}</div>
        </div>
        <div class="item">
            <div class="left">项目所在地</div>
            <div class="right">{{ detail.address }}</div>
        </div>
        <div class="item">
            <div class="left">批复金额</div>
            <div class="right">{{ detail.all_invest_num }}万元</div>
        </div>
        <div class="item">
            <div class="left">实际投资金额</div>
            <div class="right">{{ detail.real_num }}<span
                v-if="detail.real_num!==''&&detail.real_num!==undefined&&detail.real_num!==null">万元</span>
            </div>
        </div>
        <div class="item" v-for="(year,index) in years" :key="index">
            <div class="left">{{ year }}年投资金额</div>
            <div class="right">{{ detail.year_invest_num[year] }}万元</div>
        </div>
        <div class="item">
            <div class="left">建设性质</div>
            <div class="right">{{ initBuildQuality(detail.build_quality) }}</div>
        </div>
        <div class="item">
            <div class="left">项目性质</div>
            <div class="right">{{ initProjectQuality(detail.project_quality) }}</div>
        </div>
        <div class="item">
            <div class="left">项目类别</div>
            <div class="right">{{ initProjectGenre(detail.project_genre) }}</div>
        </div>
        <div class="item">
            <div class="left">本年度工作情况</div>
            <div class="right">{{ detail.year_finish === 2 ? '已完工' : '未完工' }}</div>
        </div>
        <div class="item long">
            <div class="left">项目概况</div>
            <div class="right" v-html="detail.new_project_profile"></div>
        </div>
        <div class="item">
            <div class="left">联络小组</div>
            <div class="right">{{ detail.contact_group?.name || '' }}</div>
        </div>
        <div class="item">
            <div class="left">联络小组负责人</div>
            <div class="right">{{ detail.contact_group_fuze?.nickname || '' }}
            </div>
        </div>
        <div class="item">
            <div class="left">建设单位</div>
            <div class="right">{{ construction_info?.construction_unit }}</div>
        </div>
        <div class="item">
            <div class="left">联系人</div>
            <div class="right">{{ construction_users?.map(a => a.nickname).join('、') }}</div>
        </div>
        <div class="item">
            <div class="left">开工日期</div>
            <div class="right">{{ detail.start_time || '--' }}</div>
        </div>
        <div class="item">
            <div class="left">完工日期</div>
            <div class="right">{{ detail.end_time || '--' }}</div>
        </div>
        <div class="item">
            <div class="left">负责人电话</div>
            <div class="right">{{ detail.fuze_phone }}</div>
        </div>
        <div class="item">
            <div class="left">项目分管领导</div>
            <div class="right">{{ detail.fgld }}</div>
        </div>
        <div class="item long">
            <div class="left">分管领导电话</div>
            <div class="right">{{ detail.fgld_phone }}</div>
        </div>
        <div class="item long">
            <div class="left">项目检查问题</div>
            <div class="right" v-html="detail.new_check"></div>
        </div>
        <div class="item long">
            <div class="left">项目评估内容</div>
            <div class="right" v-html="detail.new_assess"></div>
        </div>
    </div>
</template>

<script setup>
import computedData from "@/mixins/computedData";
import {computed} from "vue";

const props = defineProps({
    detail: {
        type: Object,
        default: () => {
            return {};
        }
    },
    years: {
        type: Array,
        default: () => {
            return [];
        }
    }
});

const initArea = computed(() => (e) => {
    return computedData.computed.initArea()(e);
});
const initBuildQuality = computed(() => (e) => {
    return computedData.computed.initBuildQuality()(e);
});
const initProjectQuality = computed(() => (e) => {
    return computedData.computed.initProjectQuality()(e);
});
const initProjectGenre = computed(() => (e) => {
    return computedData.computed.initProjectGenre()(e);
});
//建设单位信息
const construction_info = computed(() => {
    if (!props.detail?.construction_unit) {
        return {
            construction_unit: props.detail?.project_unit || '',
            users: [
                {
                    nickname: props.detail?.project_fuze || ''
                }
            ]
        };
    }
    let construction_list = [];
    if (props.detail?.construction_info) {
        let list = props.detail.construction_info.construction || [];
        let user_list = props.detail.construction_info.construction_users || [];
        let user_info = props.detail.construction_info.user_info || {};
        list.forEach(item => {
            item.users = user_list.filter(a => a.construction_id == item.id).map(a => {
                return user_info[a.userid] || {};
            });
        });
        construction_list = list;
    }
    return construction_list.find(a => a.id == props.detail.construction_unit) || {};
});
//建设单位负责人
const construction_users = computed(() => {
    let arr = [];
    if (construction_info.value?.users?.length) {
        arr = construction_info.value.users;
    }
    return arr;
});
</script>

<style lang="less">
@import "index.less";
</style>